import "./nav.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Center, NavLink } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCurrentUser } from "../../hooks/currentUser";

import {
  faHamsa,
  faDiceD20,
  faSnowflake,
  faAppleWhole,
} from "../../util/FontAwesomeIcons";

import { UserSettings } from "./UserSettings";
import { Logo } from "./Logo";

const Nav = () => {
  const { currentUser } = useCurrentUser();
  const navigate = useNavigate();
  const handleNav = (page) => {
    navigate(page);
  };

  if (!currentUser) {
    return null;
  }
  const { activeCharacter } = currentUser;

  const canSeeVestillion = () => {
    return !activeCharacter || activeCharacter.campaignId === "vestillion";
  };

  const canSeeCorral = () => {
    return !activeCharacter || activeCharacter.campaignId === "corral";
  };

  const canSeePrecipice = () => {
    return !activeCharacter || activeCharacter.campaignId === "precipice";
  };

  return (
    <Grid style={{ paddingTop: "5px" }}>
      <Grid.Col span="content">
        <Logo />
      </Grid.Col>
      <Grid.Col span="auto">
        <Center>
          <Grid align="center">
            <Grid.Col span="content">
              <NavLink
                leftSection={<FontAwesomeIcon icon={faDiceD20} />}
                label="Home"
                onClick={() => handleNav("/")}
              />
            </Grid.Col>
            <Grid.Col span="content">
              <NavLink
                leftSection={<FontAwesomeIcon icon={faSnowflake} />}
                label="The Vestillion Brand"
                onClick={() => handleNav("/campaigns/vestillion")}
                disabled={!canSeeVestillion()}
              />
            </Grid.Col>
            <Grid.Col span="content">
              <NavLink
                leftSection={<FontAwesomeIcon icon={faAppleWhole} />}
                label="The Corral"
                onClick={() => handleNav("/campaigns/corral")}
                disabled={!canSeeCorral()}
              />
            </Grid.Col>
            <Grid.Col span="content">
              <NavLink
                leftSection={<FontAwesomeIcon icon={faHamsa} />}
                label="Precipice"
                onClick={() => handleNav("/campaigns/precipice")}
                disabled={!canSeePrecipice()}
              />
            </Grid.Col>
          </Grid>
        </Center>
      </Grid.Col>
      <Grid.Col span="content" w="200px" align="right">
        <UserSettings />
      </Grid.Col>
    </Grid>
  );
};

export default Nav;
